import React from 'react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, selections }) => {
  if (!isOpen) return null;

  // Format message with highlighted parts
  const formatMessage = (text) => {
    const parts = text.split('"');
    return (
      <p>
        {parts[0]}
        <span className="highlighted-selection">"{parts[1]}"</span>
        {parts[2]}
        <span className="highlighted-selection">"{parts[3]}"</span>
        {parts[4]}
      </p>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{title}</h3>
        {formatMessage(message)}
        <div className="selections-list">
          {selections.map((item, index) => (
            <div key={index} className="selection-item">
              • {item}
            </div>
          ))}
        </div>
        <div className="modal-buttons">
          <button className="modal-btn cancel" onClick={onClose}>
            Keep Current Selections
          </button>
          <button className="modal-btn confirm" onClick={onConfirm}>
            Proceed with the change
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 